import { logger } from '@lusha/client-logger';
import { PLATFORM } from '@lusha/source-platforms';
import { reportClientEvent } from '@lusha/bi-client-sdk';
import { useMST } from './MSTHook';
import config from '../config';
const useReportClientEvent = (sharedProps = {}) => {
    const { userSettings, context } = useMST(store => ({ userSettings: store.userSettings, context: store.context }));
    function getPageUrl() {
        if (context.url) {
            return context.url;
        }
        const url = window.location !== window.parent.location ? document.referrer : document.location.href;
        logger.warn('[Plugin - report client event] Page url is not available. Using document.location.href. Context:', context);
        return url;
    }
    const defaultProps = {
        platform: PLATFORM.PLUGIN,
        subPlatform: userSettings.platform,
        pageUrl: getPageUrl(),
    };
    return props => reportClientEvent({
        teamName: (sharedProps === null || sharedProps === void 0 ? void 0 : sharedProps.teamName) || 'plugin',
        isLoggedIn: true,
        metadata: Object.assign(Object.assign(Object.assign(Object.assign({}, defaultProps), sharedProps), props), { eventAdditionalInfo: Object.assign(Object.assign({ plugin_version: config.version }, (sharedProps.eventAdditionalInfo || {})), (props.eventAdditionalInfo || {})) }),
    });
};
export default useReportClientEvent;
